<template>
  <div class="bg-black bg-opacity-40 justify-center items-center absolute inset-0 lg:grid z-10">
    <div class="w-full h-full rounded bg-white p-3 flex flex-col gap-y-3 relative overflow-hidden lg:w-960 lg:h-4/5 lg:p-10 lg:gap-y-5">
      <div class="flex justify-between items-center">
        <span class="text-lg font-bold">{{ $t("link.list.title") }}</span>
        <GrmCloseBtn @click="onClose" />
      </div>
      <GrmBtn class="relative"
              @click="onCreateURLShare"
      >
      {{ isCreateURLShare ? $t('link.list.add.cancel') : $t('link.list.add.title')}}
      </GrmBtn>
      <div class="min-h-0 flex-1 -mx-3 px-3 overflow-y-auto lg:-mx-10 lg:px-10">
        <div class="h-full flex flex-col relative">
          <URLShareTable/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

import GrmCloseBtn from '@/components/Common/button/GrmCloseBtn.vue'
import URLShareTable from "@/components/Room/URLShare/URLShareTable.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";

export default {
  name: 'URLShareLayer',
  components: {
    GrmBtn,
    GrmCloseBtn,
    URLShareTable,
  },
  computed: {
    ...mapState('urlShare', [
      'urlShareHistory',
      'urlShareList'
    ]),

    isCreateURLShare() {
      return this.urlShareList?.find(item => item.type === 'edit');
    }

  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    ...mapMutations('urlShare', [
      'SET_URLSHARE',
      'CREATE_URLSHARE_HISTORY',
      'REMOVE_URLSHARE_EDIT_STATE',
    ]),
    onClose() {
      this.$modal('URLShareLayer');
    },
    onCreateURLShare() {
      if (this.urlShareList.find(item => item.type === 'edit')) {
        this.REMOVE_URLSHARE_EDIT_STATE();
        return;
      }

      this.SET_URLSHARE(
          {
            type : 'edit',
            urlTitle : '',
            urlPath : ''
          }
      )
    }
  }
}
</script>
